import { combineReducers } from "redux";
import defaultReducer from "./defaultReducer";
import authReducer from "./authReducer";
import miscReducer from "./miscReducer";
import permissionsReducer from "./permissionsReducer";
import healthReducer from "./healthReducer";
import pm2Reducer from "./pm2Reducer";

const reducer = combineReducers({
  defaultReducer,
  authReducer,
  miscReducer,
  permissionsReducer,
  healthReducer,
  pm2Reducer,
});

export default reducer;
